const UserHeadsetIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6_186)">
        <path
          d="M11.086 7.15298C12.92 6.59398 14.705 7.80598 15 9.49998C15 10.328 15.672 11 16.5 11C17.328 11 18 10.328 18 9.49998C18 9.32398 17.964 9.15798 17.909 9.00098C17.3 5.48598 13.635 2.99398 9.75498 4.42798C7.45898 5.27698 6.00098 7.55198 6.00098 9.99998V10.016C6.00198 10.485 6.05798 10.941 6.16198 11.379C6.47298 12.689 8.23398 12.84 8.86098 11.649C8.86698 11.637 8.87398 11.625 8.87998 11.613C9.05798 11.285 9.12398 10.917 9.05398 10.551C8.96098 10.067 8.98598 9.54298 9.17498 9.00098C9.47898 8.12898 10.204 7.42398 11.088 7.15498L11.086 7.15298Z"
          fill="#01486D"
        />
        <path
          d="M4.61003 8.20497C4.88403 6.61197 5.66303 5.15997 6.87103 4.02697C8.40003 2.59397 10.402 1.88597 12.501 2.01597C16.454 2.27197 19.545 5.73497 19.499 9.88097C19.48 11.617 18.026 12.999 16.291 12.999H13.723C13.377 12.404 12.739 11.999 12 11.999C10.895 11.999 10 12.894 10 13.999C10 15.104 10.895 15.999 12 15.999C12.738 15.999 13.376 15.594 13.723 14.999H16.291C19.11 14.999 21.459 12.754 21.499 9.93597C21.573 4.71497 17.651 0.344971 12.63 0.0209707C9.96603 -0.152029 7.43903 0.752971 5.50403 2.56897C4.00503 3.97397 3.00803 5.83397 2.64903 7.83497C2.54003 8.44297 3.02103 9.00097 3.63803 9.00097C4.11003 9.00097 4.53103 8.67197 4.61003 8.20597V8.20497Z"
          fill="#01486D"
        />
        <path
          d="M11.9609 17C8.58395 17 5.35895 19.019 4.12095 21.909C3.79495 22.671 4.14795 23.553 4.90895 23.879C5.67195 24.204 6.55295 23.853 6.87895 23.091C7.64595 21.3 9.78395 20 11.9619 20C14.1399 20 16.3669 21.329 17.1219 23.091C17.3659 23.66 17.9199 24 18.5019 24C18.6989 24 18.8989 23.961 19.0919 23.879C19.8539 23.553 20.2059 22.67 19.8799 21.909C18.6409 19.018 15.3849 17 11.9629 17H11.9609Z"
          fill="#01486D"
        />
      </g>
      <defs>
        <clipPath id="clip0_6_186">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UserHeadsetIcon;
